<template>
  
<FormKitLazyProvider config-file="true">
<FormKit :id="id" type="step" :name="id" :label="label">
    <slot />
    <template #stepPrevious="{ handlers, stepIndex }">
      <div v-show="stepIndex">
        <button
          type="button"
          class="button"
          label="Zurück"
          data-prev="true"
          @click.prevent="handlers.incrementStep(-1)()"
        >
          Zurück
        </button>
      </div>
    </template>

    <template #stepNext="{ handlers, isLastStep }">
      <div class="ml-auto">
        <FormKit v-if="isLastStep" type="submit" :label="nextLabelMapped" />
        <button
          v-else
          type="button"
          class="button is-primary"
          label="Weiter"
          data-next="true"
          @click.prevent="handlers.incrementStep(1)()"
        >
          {{ nextLabelMapped }}
        </button>
      </div>
    </template>
  </FormKit>
</FormKitLazyProvider>

</template>

<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
const props = defineProps<{
  id: string
  label: string
  nextLabel?: string
}>()

const nextLabelMapped = computed(() => props.nextLabel || 'Weiter')
</script>
